var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "slideshow" },
    [
      _c("image-swipe", {
        ref: "swipe",
        on: {
          "next-page": function ($event) {
            return _vm.$emit("next-page")
          },
          "prev-page": function ($event) {
            return _vm.$emit("prev-page")
          },
          close: function ($event) {
            return _vm.$emit("close")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }